import {
  Routes,
  Route,
  Navigate,
  BrowserRouter as Router,
} from "react-router-dom";
import Header from "./components/Header";
import ProtectForm from "./pages/ProtectForm";
import PaymentLoading from "./pages/PaymentLoading";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailure from "./pages/PaymentFailure";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<ProtectForm />} />
        <Route path="/payment-process" element={<PaymentLoading />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failure" element={<PaymentFailure />} />
        <Route path="/payment-url" element={<PaymentFailure />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
